import React from 'react'
import { InputLabel } from '@aposphaere/ui-components'
import useProjectStatus from './utils/useProjectStatus'
import ProjectStatuses from '../ProjectsCard/ProjectStatuses'

interface Props {
  pharmacyId: number
}

function ProjectList({ pharmacyId }: Props) {
  const { validActivePayload } = useProjectStatus(pharmacyId)

  return (
    <div className="flex flex-wrap w-full">
      <div className="w-full p-4">
        <div className="w-full grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-7 pb-2 mt-4">
          <div className="sm:col-span-3">
            <InputLabel>{'Projektname:'}</InputLabel>
          </div>
          <div className="sm:col-span-4">
            <InputLabel>{'Status:'}</InputLabel>
          </div>
        </div>
        <ul className="w-full">
          {validActivePayload?.map(({ project, selectedStatusId, statusChangeHandler }) => (
            <li key={project.name} className="w-full grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-7 border-b border-gray-400 last:border-0 py-2.5">
              <div className="sm:col-span-3 flex items-center">
                <div className="flex w-full rounded-md">{project.name}</div>
              </div>
              <div className="sm:col-span-4">
                <div className="flex w-full rounded-md">
                  <ProjectStatuses projectName={project.name} selectedStatusId={selectedStatusId} statusChangeHandler={statusChangeHandler} />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ProjectList
